import { useEffect, useRef, useState } from 'react';
import html2canvas from 'html2canvas';

const IconShare = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" />
    <polyline points="16 6 12 2 8 6" />
    <line x1="12" y1="2" x2="12" y2="15" />
  </svg>
);

const IconClose = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

const BadgeIconLarge = ({ slug }) => {
  const props = { width: 56, height: 56, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 1.3, strokeLinecap: 'round', strokeLinejoin: 'round' };
  switch (slug) {
    case 'seed': return <svg {...props}><path d="M12 22V12"/><path d="M12 12C12 12 8 10 8 6a4 4 0 0 1 8 0c0 4-4 6-4 6z"/><path d="M12 15c0 0-3 1-4 4"/></svg>;
    case 'feather': return <svg {...props}><path d="M20.24 12.24a6 6 0 0 0-8.49-8.49L5 10.5V19h8.5z"/><line x1="16" y1="8" x2="2" y2="22"/><line x1="17.5" y1="15" x2="9" y2="15"/></svg>;
    case 'share': return <svg {...props}><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/></svg>;
    case 'diploma': return <svg {...props}><path d="M22 10v6M2 10l10-5 10 5-10 5z"/><path d="M6 12v5c3 3 9 3 12 0v-5"/></svg>;
    case 'calendar-check': return <svg {...props}><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/><polyline points="9 16 11 18 15 14"/></svg>;
    case 'flame': return <svg {...props}><path d="M12 2c0 0-4 4-4 8.5a4 4 0 0 0 8 0C16 6 12 2 12 2z"/><path d="M12 12c0 0-2 1.5-2 3.5a2 2 0 0 0 4 0C14 13.5 12 12 12 12z"/></svg>;
    case 'trophy': return <svg {...props}><polyline points="6 9 6 2 18 2 18 9"/><path d="M6 9a6 6 0 0 0 12 0"/><line x1="12" y1="15" x2="12" y2="19"/><line x1="8" y1="19" x2="16" y2="19"/></svg>;
    case 'book': return <svg {...props}><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/></svg>;
    case 'bookmark': return <svg {...props}><path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/></svg>;
    case 'challenge-star': return <svg {...props}><path d="M6 9H4a2 2 0 0 1-2-2V5h4"/><path d="M18 9h2a2 2 0 0 0 2-2V5h-4"/><path d="M12 17v4"/><path d="M8 21h8"/><path d="M6 5h12v6a6 6 0 0 1-6 6 6 6 0 0 1-6-6V5z"/></svg>;
    case 'challenge-flame': return <svg {...props}><path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z"/></svg>;
    case 'challenge-heart': return <svg {...props}><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>;
    default: return <svg {...props}><circle cx="12" cy="12" r="9"/></svg>;
  }
};

function ShareCard({ badge, cardRef }) {
  const s = {
    card: {
      width: 360, height: 640,
      background: 'linear-gradient(160deg, #2f2b5f 0%, #1a1838 100%)',
      display: 'flex', flexDirection: 'column', justifyContent: 'space-between',
      padding: '36px 32px 32px',
      position: 'relative', overflow: 'hidden',
      fontFamily: "'DM Sans', sans-serif",
      boxSizing: 'border-box',
    },
    blob1: {
      position: 'absolute', borderRadius: '50%', pointerEvents: 'none',
      width: 280, height: 280,
      background: 'radial-gradient(circle, rgba(123,94,167,0.35) 0%, transparent 70%)',
      top: -60, right: -80,
    },
    blob2: {
      position: 'absolute', borderRadius: '50%', pointerEvents: 'none',
      width: 220, height: 220,
      background: 'radial-gradient(circle, rgba(111,174,143,0.2) 0%, transparent 70%)',
      bottom: 40, left: -60,
    },
    blob3: {
      position: 'absolute', borderRadius: '50%', pointerEvents: 'none',
      width: 160, height: 160,
      background: 'radial-gradient(circle, rgba(255,255,255,0.04) 0%, transparent 70%)',
      top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
    },
    header: {
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      position: 'relative', zIndex: 1,
    },
    headerLeft: { display: 'flex', alignItems: 'center', gap: 7 },
    logoText: {
      fontFamily: "'Cormorant Garamond', Georgia, serif",
      fontSize: 17, fontWeight: 500, color: 'rgba(255,255,255,0.9)', letterSpacing: '0.01em',
    },
    ig: { display: 'flex', alignItems: 'center', gap: 4 },
    igHandle: { fontSize: 11, color: 'rgba(255,255,255,0.35)', letterSpacing: '0.01em' },
    body: {
      display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0,
      position: 'relative', zIndex: 1, flex: 1,
      justifyContent: 'center', padding: '20px 0',
    },
    label: {
      fontSize: 10, fontWeight: 600, letterSpacing: '0.13em', textTransform: 'uppercase',
      color: 'rgba(255,255,255,0.45)', margin: '0 0 14px',
    },
    divider: { width: 36, height: 1, background: 'rgba(255,255,255,0.2)', margin: '0 auto 20px' },
    iconCircle: {
      width: 100, height: 100,
      background: 'rgba(255,255,255,0.1)',
      borderRadius: '50%',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      color: '#fff', marginBottom: 22,
      border: '1px solid rgba(255,255,255,0.15)',
    },
    badgeName: {
      fontFamily: "'Cormorant Garamond', Georgia, serif",
      fontSize: 32, fontWeight: 600, color: '#fff',
      lineHeight: 1.15, textAlign: 'center', margin: '0 0 12px',
    },
    badgeDesc: {
      fontSize: 14, fontWeight: 300, color: 'rgba(255,255,255,0.7)',
      lineHeight: 1.6, textAlign: 'center', margin: '0 0 22px',
    },
    divider2: { width: 36, height: 1, background: 'rgba(255,255,255,0.2)', margin: '0 auto 18px' },
    tagline: {
      fontSize: 12, fontWeight: 400, color: 'rgba(255,255,255,0.45)',
      textAlign: 'center', lineHeight: 1.6, margin: 0,
      fontStyle: 'italic',
    },
    footer: { position: 'relative', zIndex: 1, textAlign: 'center' },
    footerCta: {
      fontSize: 13, fontWeight: 500, color: 'rgba(255,255,255,0.6)',
      margin: '0 0 5px', letterSpacing: '0.01em',
    },
    footerUrl: {
      fontSize: 12, fontWeight: 600,
      color: '#a990d0', margin: 0, letterSpacing: '0.01em',
    },
  };

  return (
    <div ref={cardRef} style={s.card}>
      <div style={s.blob1} />
      <div style={s.blob2} />
      <div style={s.blob3} />

      {/* Header */}
      <div style={s.header}>
        <div style={s.headerLeft}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="#a990d0">
            <path d="M12 2 L13.8 10.2 L22 12 L13.8 13.8 L12 22 L10.2 13.8 L2 12 L10.2 10.2 Z"/>
          </svg>
          <span style={s.logoText}>Clube do Eu</span>
        </div>
        <div style={s.ig}>
          <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.3)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
            <circle cx="12" cy="12" r="4"/>
            <circle cx="17.5" cy="6.5" r="0.5" fill="rgba(255,255,255,0.3)" stroke="none"/>
          </svg>
          <span style={s.igHandle}>@oclubedoeu</span>
        </div>
      </div>

      {/* Body */}
      <div style={s.body}>
        <p style={s.label}>Conquista desbloqueada</p>
        <div style={s.divider} />
        <div style={s.iconCircle}>
          <BadgeIconLarge slug={badge.iconSlug} />
        </div>
        <p style={s.badgeName}>{badge.name}</p>
        <p style={s.badgeDesc}>{badge.description}</p>
        <div style={s.divider2} />
        <p style={s.tagline}>A comunidade onde exploramos os vários eus que existem dentro de nós.</p>
      </div>

      {/* Footer */}
      <div style={s.footer}>
        <p style={s.footerCta}>Comece sua jornada →</p>
        <p style={s.footerUrl}>app.oclubedoeu.com.br</p>
      </div>
    </div>
  );
}

export default function BadgeCelebrationModal({ badges, onDismiss }) {
  const [index, setIndex] = useState(0);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [gerando, setGerando] = useState(false);
  const [erro, setErro] = useState(false);
  const cardRef = useRef(null);

  const badge = badges[index];

  useEffect(() => {
    if (!badge) return;
    setPreviewUrl(null);
    setErro(false);
    let cancelled = false;

    const gerar = async () => {
      setGerando(true);
      try { await document.fonts.ready; } catch {}
      await new Promise(r => setTimeout(r, 120));
      if (cancelled || !cardRef.current) { setGerando(false); return; }
      try {
        const scale = Math.min(window.devicePixelRatio || 2, 2);
        const canvas = await html2canvas(cardRef.current, {
          scale,
          useCORS: true,
          allowTaint: true,
          backgroundColor: '#2f2b5f',
          logging: false,
          foreignObjectRendering: false,
        });
        if (!cancelled) setPreviewUrl(canvas.toDataURL('image/png'));
      } catch {
        if (!cancelled) setErro(true);
      } finally {
        if (!cancelled) setGerando(false);
      }
    };

    gerar();
    return () => { cancelled = true; };
  }, [badge]);

  const handleShare = async () => {
    if (!previewUrl) return;
    try {
      const res = await fetch(previewUrl);
      const blob = await res.blob();
      const file = new File([blob], 'conquista-clube-do-eu.png', { type: 'image/png' });
      if (navigator.canShare && navigator.canShare({ files: [file] })) {
        await navigator.share({ files: [file], title: `Conquista: ${badge.name} — Clube do Eu` });
        return;
      }
      handleDownload();
    } catch {
      handleDownload();
    }
  };

  const handleDownload = () => {
    if (!previewUrl) return;
    const link = document.createElement('a');
    link.download = 'conquista-clube-do-eu.png';
    link.href = previewUrl;
    link.click();
  };

  const handleCompartilharTexto = async () => {
    const texto = `Desbloqueei a conquista "${badge?.name}" no Clube do Eu ✨`;
    try {
      if (navigator.canShare && navigator.canShare()) {
        await navigator.share({ text: texto, title: 'Minha conquista — Clube do Eu' });
      } else {
        await navigator.clipboard.writeText(texto);
        alert('Texto copiado para a área de transferência!');
      }
    } catch {}
  };

  const handleProxima = () => {
    if (index < badges.length - 1) {
      setIndex(i => i + 1);
    } else {
      onDismiss();
    }
  };

  const [showPreview, setShowPreview] = useState(false);

  if (!badge) return null;

  return (
    <>
      {/* Card off-screen para captura */}
      <div style={{ position: 'absolute', overflow: 'hidden', width: 0, height: 0, top: 0, left: 0, pointerEvents: 'none', zIndex: -1 }}>
        <ShareCard badge={badge} cardRef={cardRef} />
      </div>

      {/* Modal */}
      <div className="modal-celebracao-backdrop">
        <div className="modal-celebracao-card">
          <div className="modal-celebracao-decor" />

          <div className="modal-celebracao-icone">
            <BadgeIconLarge slug={badge.iconSlug} />
          </div>

          <div className="modal-celebracao-texto">
            <p className="modal-celebracao-supra">Conquista desbloqueada 🎉</p>
            <h2 className="modal-celebracao-titulo">{badge.name}</h2>
            <p className="modal-celebracao-mensagem">{badge.description}</p>
          </div>

          <div className="modal-celebracao-acoes">
            {gerando && (
              <button className="btn btn-primary" style={{ width: '100%' }} disabled>
                Gerando imagem...
              </button>
            )}

            {!gerando && previewUrl && (
              <button
                className="btn btn-primary"
                style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}
                onClick={() => setShowPreview(true)}
              >
                <IconShare />
                Compartilhar conquista
              </button>
            )}

            {!gerando && erro && (
              <button
                className="btn btn-primary"
                style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}
                onClick={handleCompartilharTexto}
              >
                <IconShare />
                Compartilhar conquista
              </button>
            )}

            <button className="btn btn-ghost" style={{ width: '100%' }} onClick={handleProxima}>
              {index < badges.length - 1 ? 'Próxima conquista' : 'Fechar'}
            </button>
          </div>

          <button className="modal-celebracao-fechar" onClick={onDismiss} aria-label="Fechar">
            <IconClose />
          </button>
        </div>
      </div>

      {/* Preview da imagem — renderizado depois da modal para ficar na frente */}
      {showPreview && previewUrl && (
        <div className="oracle-preview-backdrop" onClick={() => setShowPreview(false)}>
          <div className="oracle-preview-box" onClick={e => e.stopPropagation()}>
            <p className="oracle-preview-hint">Toque e segure para salvar · ou compartilhe abaixo</p>
            <img
              src={previewUrl}
              alt="Conquista para compartilhar"
              className="oracle-preview-img"
              draggable={false}
              onClick={handleShare}
              style={{ cursor: 'pointer' }}
            />
            <button className="btn btn-primary" style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }} onClick={handleShare}>
              <IconShare />
              Compartilhar / Salvar imagem
            </button>
            <button className="btn btn-ghost oracle-preview-close" onClick={() => setShowPreview(false)}>
              Fechar
            </button>
          </div>
        </div>
      )}
    </>
  );
}
